import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dialogApiInjectionKey as r } from "./context.js";
import { throwError as i } from "../../_utils/naive/warn.js";
import { inject as t } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function d() {
  const o = t(r, null);
  return o === null && i("use-dialog", "No outer <n-dialog-provider /> founded."), o;
}
export {
  d as useDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dialog/src/composables.js
// module id = 481
// module chunks = 67